var _path, _path2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-uy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0038a8",
    d: "M284 56.889h228v56.889H284zm0 113.778h228v56.889H284zM0 284.444h512v56.889H0zm0 113.778h512v56.889H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.222 142.222) scale(3.12889)",
    strokeMiterlimit: 20,
    fill: "#fcd116",
    stroke: "#000",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9L6 12c-8 13 1 15-6 21 3-7-3-5-3-17",
    strokeLinecap: "square",
    transform: "rotate(22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11c-2 13 4.5 17 0 22",
    fill: "none",
    transform: "rotate(22.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6L0 33-6 0h6v33"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#c",
    transform: "scale(-1)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.222 142.222) scale(.31289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81-44c-7 8-11-6-36-6S16-35 12-38s21-21 29-22 31 7 40 16m-29 9c7 6 1 19-6 19S26-28 32-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19-26c1-12 11-14 27-14s23 12 29 15c-7 0-13-10-29-10s-16 0-27 10m3 2c4-6 9 6 20 6s17-3 24-8-10 12-21 12-26-6-23-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56-17c13-7 5-17 0-19 2 2 10 12 0 19M0 43c6 0 8-2 16-2s27 11 38 7c-23 9-14 3-54 3h-5m63 6c-4-7-3-5-11-16 8 6 10 9 11 16M0 67c25 0 21-5 54-19-24 3-29 11-54 11h-5m5-29c7 0 9-5 17-5s19 3 24 7c1 1-3-8-11-9S25 9 16 7c0 4 3 3 4 9 0 5-9 5-11 0 2 8-4 8-9 8"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 76c-5 0-18 3 0 3s5-3 0-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/uy.6cdf73a4c8db0526a6b0c4c1c599e544.svg";
export { ForwardRef as ReactComponent };